import React from "react";
import "./Modal.scss";
import Button from "@components/button/Button";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Modal(props) {
  return (
    <>
      {props.showModal && (
        <div className={`Modal`}>
          <div
            className={`modal-body col-12 col-sm-4 col-xl-3`}
            style={{
              width: props.width,
              ...(props.height && { height: props.height }),
            }}
          >
            <div className="modal-title">
              {props.title && (
                <p className="modal-title">
                  <strong>{props.title}</strong>
                </p>
              )}
              {props.botaoExcluir && (
                <ButtonIcon
                  Excluir
                  onExcluir={() => {
                    props.setShowModal(false);
                  }}
                />
              )}
            </div>
            <div className="body">{props.children}</div>
            <div className="modal-button">
              {props.showButton001 && (
                <Button
                  nome={props.button001_Nome}
                  onClick={props.button001_onClick}
                  theme={2}
                />
              )}
              {props.showButton002 && (
                <Button
                  nome={props.button002_Nome}
                  onClick={props.button002_onClick}
                  theme={2}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

Modal.defaultProps = {
  className: "",
  showModal: false,
  botaoExcluir: true,
  setShowModal: () => null,
  width: "",
  height: null,
  //Button001
  button001_Nome: "Sim",
  button001_onClick: () => null,
  showButton001: false,
  //Button002
  button002_Nome: "Não",
  button002_onClick: () => null,
  showButton001: false,
};
